import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { FC } from 'react';
import { Role } from '@/models/user';
import useSession from '@/hooks/useSession';

interface RouteGuardProps {
  allowedRoles?: Array<Role>;
}

const RouteGuard: FC<RouteGuardProps> = ({ allowedRoles }) => {
  const { session } = useSession();
  const location = useLocation();

  const isAllowed =
    typeof allowedRoles === 'undefined'
      ? session.roles.length > 0
      : session.roles.some((role) => allowedRoles.includes(role));

  return isAllowed ? (
    <Outlet />
  ) : session?.email ? (
    <Navigate
      to={{
        pathname: '/not-found',
      }}
      state={{ from: location }}
      replace
    />
  ) : (
    <Navigate
      to={{
        pathname: '/sign-in',
        search: location.search,
      }}
      state={{ from: location }}
      replace
    />
  );
};

export default RouteGuard;
